import axiosInstance from "../services/AxiosInstance";
import { billingdataInstance } from "../services/AxiosInstance";
import { axiosPlacement } from "./AxiosInstance"; // ADDED for placement officers

const API_URL = "/courses";

export const getcourses = async (limit = 1000, page = 1, search = '', filters = {}) => {
  try {
    let url = `/lms/courses?limit=${limit}&page=${page}&search=${search}`;
    
    // Add additional filters to the URL
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        url += `&${key}=${encodeURIComponent(filters[key])}`;
      }
    });

    const response = await axiosInstance.get(url);
    return {
      data: response.data?.data || [],
      pagination: response.data?.pagination || {},
    };
  } catch (error) {
    console.error("❌ GET courseList error:", error.message, error.response?.data);
    throw error;
  }
};

// Create a new course
export const createcourses = async (courseData) => {
  try {
    const response = await axiosInstance.post(API_URL, courseData);
    return response.data;
  } catch (error) {
    console.error("Error creating course", {
      error: error.response?.data,
      requestData: courseData,
    });
    throw error;
  }
};

// Update a course by ID
export const updatecourses = async (courseId, courseData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${courseId}`, courseData);
    return response.data;
  } catch (error) {
    console.error("Error updating course", error);
    throw error;
  }
};

// Delete a course by ID
export const deletecourses = async (courseId) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${courseId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting course", error);
    throw error;
  }
};

// Get a course by ID
export const getcoursesById = async (courseId) => {
  try {
    const response = await billingdataInstance.get(`${API_URL}/${courseId}`);
    return {
      data: response.data.data,
      status: response.status,
      message: response.data.message,
    };
  } catch (error) {
    console.error("Error fetching course details", error);
    throw error;
  }
};

/**
 * v2 billing app integrations (NEW)
 * Endpoints:
 *  - GET /departments
 *  - GET /branches
 */
export const getDepartmentsV2 = async (limit = 1000, page = 1, search = '') => {
  try {
    // Using GET with pagination parameters
    const response = await axiosInstance.get(`/departments?limit=${limit}&page=${page}&search=${search}`);
    // Support both { data: [...] } and plain array responses
    if (response.data?.data && Array.isArray(response.data.data)) {
      return {
        data: response.data.data,
        pagination: response.data.pagination || { total: response.data.data.length, page, limit, totalPages: 1 }
      };
    }
    // Handle plain array response
    if (Array.isArray(response.data)) {
      return {
        data: response.data,
        pagination: { total: response.data.length, page, limit, totalPages: 1 }
      };
    }
    // Handle { data: [...] } structure without pagination
    if (response.data?.data && Array.isArray(response.data.data)) {
      return {
        data: response.data.data,
        pagination: { total: response.data.data.length, page, limit, totalPages: 1 }
      };
    }
    return {
      data: [],
      pagination: { total: 0, page, limit, totalPages: 0 }
    };
  } catch (error) {
    console.error("❌ GET departments (v2) error:", error.message, error.response?.data);
    throw error;
  }
};

export const getBranchesV2 = async (limit = 50000) => {
  try {
    const res = await axiosInstance.get(`/branches?limit=${limit}`);
    // Support both { data: [...] } and plain array responses
    return res.data?.data || res.data || [];
  } catch (error) {
    console.error("❌ GET branches (v2) error:", error.message, error.response?.data);
    throw error;
  }
};

// NEW: Get placement officers for assignedTo field
export const getPlacementOfficers = async (limit = 20, page = 1, search = '') => {
  try {
    const response = await axiosPlacement.get(`/placementofficers?page=${page}&limit=${limit}${search ? `&search=${search}` : ''}`);
    return {
      data: response.data?.data || [],
      pagination: response.data?.pagination || { total: 0, page, limit, totalPages: 0 },
      message: response.data?.message
    };
  } catch (error) {
    console.error("❌ GET placement officers error:", error.message, error.response?.data);
    throw error;
  }
};